var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pad-separator"},[_c('vb-icon',{staticClass:"mr-2",attrs:{"name":'lamp_light',"color":'#003B95'}}),_c('span',[(_vm.search_count)?_c('strong',[_vm._v("E se ti spostassi un po'?")]):_c('strong',[_vm._v("Non abbiamo trovato niente.")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.message))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }